/* eslint-disable */
import React, { Fragment, useEffect, useState, Dispatch, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { TextField, Button, Select, MenuItem, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import ActionButtons from './ActionButtons';
import { get } from 'lodash';
import { saveKamReviewDetails, getKamDetails, getDealerDetails, deleteDocument, } from '../../store/actions/editDealer.actions';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from "moment-timezone";
import { deleteKamReviewsDocument, resetValues, updateDocument } from '../../store/actions/editDealer.actions';
import DeleteDialog from '../../common/components/deleteDialog';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import { KamReviewValidationMessages } from '../../constants/messages';
import { updateDealerData } from '../../store/actions/dealer.action';
import { KeyboardDatePicker } from '@material-ui/pickers';
import FullscreenLoader from '../../common/components/FullscreenLoader';
import { getIndustryType } from '../../store/actions/onboard.actions';
import { FormControl, Tooltip, InputAdornment, Checkbox } from '@material-ui/core';
import { FormControlLabel, Radio, RadioGroup, } from "@material-ui/core";
import { getRefreshDataFromSAPCustomerDetails } from "../../store/actions/dealer.action";
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned';
import { downloadCategoryCertificate, updateCustomerAgreementDocument, getCustomerAgreementDocument } from '../../store/actions/onboard.actions';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const KamReview = (props: any) => {
  const dispatch: Dispatch<any> = useDispatch();
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [isEdited, setIsEdited] = React.useState<boolean>(false);
  const [successMessage, setSuccessMessage] = React.useState<any>(null);
  const { dealerDetails }: any = useSelector((state: any) => state.dealer);
  const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
  const [loading, setLoading] = React.useState<any>(true);
  const [setSave, SetSave] = React.useState<boolean>(false);
  const [setSize, SetSize] = React.useState<string>("");
  const [setSizeError, SetSizeError] = React.useState<boolean>(false);
  const [invalidSetSize, setInvalidSetSize] = React.useState<boolean>(false);
  const [setSizeValidationMessage, SetSizeValidationMessage] = React.useState<string>("");
  const [setStock, SetStock] = React.useState<string>("");
  const [setStockError, SetStockError] = React.useState<boolean>(false);
  const [invalidSetStock, setInvalidSetStock] = React.useState<boolean>(false);
  const [setStockValidationMessage, SetStockValidationMessage] = React.useState<string>("");
  const [setNumberOfStaff, SetNumberOfStaff] = React.useState<string>("");
  const [setNumberOfStaffError, SetNumberOfStaffError] = React.useState<boolean>(false);
  const [invalidSetNumberOfStaff, setInvalidSetNumberOfStaff] = React.useState<boolean>(false);
  const [setNumberOfStaffValidationMessage, SetNumberOfStaffValidationMessage] = React.useState<string>("");
  const [setSalesToCustomer, SetSalesToCustomer] = React.useState<string>("");
  const [setSalesToCustomerError, SetSalesToCustomerError] = React.useState<boolean>(false);
  const [invalidSetSalesToCustomer, setInvalidSetSalesToCustomer] = React.useState<boolean>(false);
  const [setSalesToCustomerValidationMessage, SetSalesToCustomerValidationMessage] = React.useState<string>("");
  const [setSalesToCustomerCurrencyType, SetSalesToCustomerCurrencyType] = React.useState<any>("AED");
  const [setSalesToCustomerCurrencyTypeError, SetSalesToCustomerCurrencyTypeError] = React.useState<boolean>(false);
  const [invalidSetSalesToCustomerCurrencyType, setInvalidSetSalesToCustomerCurrencyType] = React.useState<boolean>(false);
  const [setSalesToCustomerCurrencyTypeValidationMessage, SetSalesToCustomerCurrencyTypeValidationMessage] = React.useState<string>("");
  const [setSalesSince, SetSalesSince] = React.useState<any>(null);
  const [setSalesSinceError, SetSalesSinceError] = React.useState<boolean>(false);
  const [isValidSalesSinceExpiryDate, setIsValidSalesSinceExpiryDate] = React.useState<any>(true);
  const [invalidSetSalesSince, setInvalidSetSalesSince] = React.useState<boolean>(false);
  const [setSalesSinceValidationMessage, SetSalesSinceValidationMessage] = React.useState<string>("");
  const [setPaymentHistory, SetPaymentHistory] = React.useState<string>("");
  const [setPaymentHistoryError, SetPaymentHistoryError] = React.useState<boolean>(false);
  const [invalidSetPaymentHistory, setInvalidSetPaymentHistory] = React.useState<boolean>(false);
  const [setPaymentHistoryValidationMessage, SetPaymentHistoryValidationMessage] = React.useState<string>("");
  const [setGrowthPlan, SetGrowthPlan] = React.useState<string>("");
  const [setGrowthPlanError, SetGrowthPlanError] = React.useState<boolean>(false);
  const [invalidSetGrowthPlan, setInvalidSetGrowthPlan] = React.useState<boolean>(false);
  const [setGrowthPlanValidationMessage, SetGrowthPlanValidationMessage] = React.useState<string>("");
  const [setPictureOfHo, SetPictureOfHo] = React.useState<any>([]);
  const [setPictureOfHoError, SetPictureOfHoError] = React.useState<boolean>(false);
  const [invalidSetPictureOfHo, setInvalidSetPictureOfHo] = React.useState<boolean>(false);
  const [setPictureOfHoValidationMessage, SetPictureOfHoValidationMessage] = React.useState<string>("");
  const [error, setError] = React.useState<any>(null);
  const [invalidDate, setInvalidDate] = React.useState<boolean>(false);
  const [establishedDate, setEstablishedDate] = React.useState<any>(null);
  const [establishedDateError, setEstablishedDateError] = React.useState<boolean>(false);
  const [setSapCustomerId, SetSapCustomerId] = React.useState<any>(null);
  const [errorMessage, showErrorMessage] = React.useState<any>(null);
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [currentIndex, setCurrentIndex] = React.useState<any>();
  const isAddedByFse = sessionStorage.getItem('isAddedByFse') === 'FSE' ? true : false;
  const assignFse = sessionStorage.getItem('assignFse');
  const isTpcDealer = sessionStorage.getItem('customerOnboardingType') === 'tpcdealer';
  const [companyIndustrySector, setCompanyIndustrySector] = React.useState<any>(isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? "900" : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "tpcdealer" ? "901" : "");
  const [rdc, setRDC] = React.useState<any>("")
  const [selectedIndustryTypeError, setSelectedIndustryTypeError] = React.useState<boolean>(false);
  const [invalidSelectedIndustryType, setInvalidSelectedIndustryType] = React.useState<boolean>(false);
  const currencies = ["AED"];
  const [dealerstatus, setStatus] = React.useState<any>("");
  const [kamReviewDetailsObj, setKamReviewDetailsObj] = React.useState<any>([
    {
      size: "",
      stock: "",
      numberOfStaff: "",
      growthPlan: "",
      salesSince: "",
      paymentHistory: "",
      salesToCutomerCurrencyType: "",
      salesToCutomer: "",
      pictureOfHo: [{}],
      companyIndustrySector: "",
      addedBy: "",
      lastUpdateDate: ""
    }
  ])
  const { selectedNewDealer, isEditDealer }: any = useSelector((state: any) => state.dealer);
  let b2bUserId: any = selectedNewDealer && selectedNewDealer.createdByB2bUserId;
  let sapCustomerId: any = selectedNewDealer && selectedNewDealer.sapCustomerId;
  const webApplicationLoginId = sessionStorage.getItem('webApplicationLoginId');
  const { getIndustryTypeAPI }: any = useSelector((state: any) => state.onboard);
  const ibCurrencyType = sessionStorage.getItem('ibCurrency');
  const [ibCurrency, setIbCurrency] = React.useState<any>(ibCurrencyType);
  const [bulkPartnerType, setBulkPartnerType] = React.useState<any>("");
  const [isBulkPartner, setBulkPartner] = React.useState<any>("");
  const [bulkPartnerTypeError, setBulkPartnerTypeError] = React.useState<boolean>(false);
  const displayName = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.displayName;
  const [customerAgreement, setCustomerAgreement] = React.useState<any>([]);
  const [categoryCertificate, setCategoryCertificate] = React.useState<any>([]);
  const [annexureToAgreement, setAnnexureToAgreement] = React.useState<any>([]);
  const { categoryCertificateResponse }: any = useSelector((state: any) => state.onboard);
  const [deleteDocumentRemovalType, setDeleteDocumentRemovalType] = React.useState<any>("");
  let userType = sessionStorage.getItem('userType');
  const { getDocumentAccessKamListData }: any = useSelector((state: any) => state.profileDetails);

  const handleopenCloseSnackbar = (open?: any) => {
    setOpenSnackbar(open ? true : false);
  };

  const handleopenCloseErrorSnackbar = (open?: any) => {
    setOpenErrorSnackbar(open ? true : false);
  };

  const handleClose = () => {
    setOpen(false);
    setSuccessMessage(null);
  };

  const handleClickOpen = () => {
    setOpen(true);
    setIsEdited(false);
  };

  const handleopenClose = (open?: any) => {
    setOpenDeleteDialog(open ? true : false);
  };

  const onClickEditAddress = async () => {
    setIsEdited(true);
    setOpen(true);
  }

  useEffect(() => {
    loadKamDetails();
    dispatch(getIndustryType(sessionStorage.getItem('customerOnboardingType')));
    if (sessionStorage.getItem('customerOnboardingType') === "Int. Business") {
      setCompanyIndustrySector("906");
    }
  }, []);

  const loadKamDetails = async () => {
    setLoading(true);
    let response: any = await dispatch(getDealerDetails(sapCustomerId, 'kamReview'));
    if (response) {
      setLoading(false);
      if (response.data) {
        KamReviewDetails(response);
      }
    }
  }

  function deleteDocumentDialog(type: any) {
    setOpenDeleteDialog(true);
    setSuccessMessage(null);
    setDeleteDocumentRemovalType(type);
  }

  // ONCHANGE OF SELECT INDUSTRY TYPE
  const onChangeIndustryType = (e: any) => {
    setCompanyIndustrySector(e.target.value);
    if (e.target.value === "" || e.target.value.trim() === "") {
      setSelectedIndustryTypeError(true);
    }
    else {
      setSelectedIndustryTypeError(false);
    }
  }

  const downloadCustomerAgreement = async (file: any) => {
    try {
      setLoading(true);
      const filename: any = file.documentId?.selectedFileName ? file.documentId?.selectedFileName : file.documentId?.fileNmae;
      await dispatch(getCustomerAgreementDocument(file.documentId?.sapCustomerId, file.fileIds, filename));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  function KamReviewDetails(data: any) {
    if (data.data.kamReview) {
      let duplicate = data.data.kamReview;
      if (data.data.sapCustomerId) {
        SetSapCustomerId(data.data.sapCustomerId);
      }
      if (duplicate.size) {
        SetSize(duplicate.size);
      }
      if (duplicate.stock) {
        SetStock(duplicate.stock);
      }
      if (duplicate.numberOfStaff) {
        SetNumberOfStaff(duplicate.numberOfStaff)
      }
      if (duplicate.salesToCutomer) {
        SetSalesToCustomer(duplicate.salesToCutomer);
      }
      if (duplicate.salesToCutomerCurrencyType) {
        SetSalesToCustomerCurrencyType(duplicate.salesToCutomerCurrencyType)
      }
      if (duplicate.salesSince) {
        SetSalesSince(duplicate.salesSince);
      }
      if (duplicate.paymentHistory) {
        SetPaymentHistory(duplicate.paymentHistory);
      }
      if (duplicate.companyIndustrySector) {
        setCompanyIndustrySector(duplicate.companyIndustrySector);
      }
      if (duplicate.growthPlan) {
        SetGrowthPlan(duplicate.growthPlan);
      }
      if (duplicate.pictureOfHo && duplicate.pictureOfHo.length) {
        let pictures = duplicate.pictureOfHo.filter((data: any) => data.documentId != null && data.documentId)
        SetPictureOfHo(pictures);
      }
      if (duplicate.customerAgreement && duplicate.customerAgreement.length) {
        let customerAgreement = duplicate.customerAgreement.filter((data: any) => data.documentId != null && data.documentId)
        setCustomerAgreement(customerAgreement);
      }
      if (duplicate.annexureToAgreement && duplicate.annexureToAgreement.length) {
        let annexureToAgreement = duplicate.annexureToAgreement.filter((data: any) => data.documentId != null && data.documentId)
        setAnnexureToAgreement(annexureToAgreement);
      }
    }
    if (data.data.status) {
      setStatus(data.data.status);
    }
  }

  function saveValidation() {
    SetSave(true);
    let validationSuccess = true;
    if (
      sessionStorage.getItem('customerOnboardingType') === 'Dealer' ||
      sessionStorage.getItem('customerOnboardingType') === "TBL Dealer" ||
      sessionStorage.getItem('customerOnboardingType') === 'dealer' ||
      sessionStorage.getItem('customerOnboardingType') === 'workshop' ||
      sessionStorage.getItem('customerOnboardingType') === 'Workshop'
    ) {
      if (!setSize || setSizeError) {
        SetSizeError(true);
        validationSuccess = false
      }
      else {
        SetSizeError(false);
      }
      if (sessionStorage.getItem('customerOnboardingType') !== "Int. Business") {
        if (!setStock || setStockError) {
          SetStockError(true);
          validationSuccess = false;
        }
        else {
          SetStockError(false);
        }
      }
      if (sessionStorage.getItem('customerOnboardingType') !== "Int. Business") {
        if (!setNumberOfStaff || setNumberOfStaffError) {
          SetNumberOfStaffError(true);
          validationSuccess = false;
        }
        else {
          SetNumberOfStaffError(false);
        }
      }
      if (!setSalesToCustomer || setSalesToCustomerError) {
        SetSalesToCustomerError(true);
        validationSuccess = false;
      }
      else {
        SetSalesToCustomerError(false);
      }
      if (!setSalesToCustomerCurrencyType || setSalesToCustomerCurrencyTypeError) {
        SetSalesToCustomerCurrencyTypeError(true);
        validationSuccess = false;
      }
      else {
        SetSalesToCustomerCurrencyTypeError(false);
      }
      if (!setSalesSince || setSalesSinceError) {
        SetSalesSinceError(true);
        validationSuccess = false;
      }
      else {
        SetSalesSinceError(false);
      }
      if (!setPaymentHistory || setPaymentHistoryError) {
        SetPaymentHistoryError(true);
        validationSuccess = false;
      }
      else {
        SetPaymentHistoryError(false);
      }
    }
    if (!companyIndustrySector && companyIndustrySector == "" || companyIndustrySector == undefined) {
      setSelectedIndustryTypeError(true);
      validationSuccess = false;
    }
    else {
      setSelectedIndustryTypeError(false);
    }

    if (
      sessionStorage.getItem('customerOnboardingType') === 'Dealer' ||
      sessionStorage.getItem('customerOnboardingType') === "TBL Dealer" ||
      sessionStorage.getItem('customerOnboardingType') === 'dealer' ||
      sessionStorage.getItem('customerOnboardingType') === 'workshop' ||
      sessionStorage.getItem('customerOnboardingType') === 'Workshop'
    ) {
      if (!setGrowthPlan || setGrowthPlanError) {
        SetGrowthPlanError(true);
        validationSuccess = false;
      }
      else {
        SetGrowthPlanError(false);
      }

      if (setPictureOfHo.length == 0) {
        validationSuccess = false;
      }
    }

    let selectedPO: any = [];
    if (setPictureOfHo && setPictureOfHo.length > 0) {
      setPictureOfHo.map((po: any) => {
        if (po.documentId && po.documentId.id) {
          selectedPO.push({ documentId: po.documentId.id })
        }
      })
    }

    let selectedCustomerAgreement: any = [];
    if (customerAgreement && customerAgreement.length > 0) {
      customerAgreement.map((po: any) => {
        if ((po.documentId && po.documentId.id) || po.fileIds) {
          selectedCustomerAgreement.push({ documentId: po.fileIds })
        }
      })
    }

    let selectedAnnexureToAgreement: any = [];
    if (annexureToAgreement && annexureToAgreement.length > 0) {
      annexureToAgreement.map((po: any) => {
        if (po.documentId && po.documentId.id) {
          selectedAnnexureToAgreement.push({ documentId: po.documentId.id })
        }
      })
    }

    let kamReviewPayload = {
      size: setSize,
      stock: setStock,
      numberOfStaff: setNumberOfStaff,
      growthPlan: setGrowthPlan,
      salesSince: setSalesSince,
      paymentHistory: setPaymentHistory,
      salesToCutomerCurrencyType: setSalesToCustomerCurrencyType,
      salesToCutomer: setSalesToCustomer,
      pictureOfHo: selectedPO,
      customerAgreement: selectedCustomerAgreement,
      annexureToAgreement: selectedAnnexureToAgreement,
      companyIndustrySector: companyIndustrySector,
      addedBy: sessionStorage.getItem('webApplicationLoginId'),
      lastUpdateDate: moment(new Date()).utc().format()
    }
    setKamReviewDetailsObj(kamReviewPayload);
    let finalPayload = {
      b2bUserId: b2bUserId,
      sapCustomerId: sapCustomerId,
      kamReview: kamReviewPayload
    }
    if (validationSuccess) {
      saveKamReview(finalPayload);
    } else {
      showErrorMessage('Please fill all mandatory fields');
      handleopenCloseErrorSnackbar(true);
    }
  }

  const saveKamReview = async (payload: any) => {
    setLoading(true);
    let response: any = await dispatch(updateDealerData(sapCustomerId, payload));
    if (response && response.message && response.message.status === 'S') {
      props.setDataUpdated(false);
      props.setselectedTab(4);
      setOpenSnackbar(true);
      SetSave(false);
      props.handleopenCloseSnackbar(true);
      props.setSuccessMessage("Customer details updated successfully")
      setTimeout(() => {
        setOpenSnackbar(false);
      }, 2000);
    }
    setLoading(false);
  }


  const downloadCertificate = async () => {
    setLoading(true);
    let payload = {
      "customerName": dealerDetails && dealerDetails.data && dealerDetails.data.data && dealerDetails.data.data.companyName ? dealerDetails.data.data.companyName : "",
      "currentYear": new Date().getUTCFullYear()
    }
    let responseData: any = await dispatch(downloadCategoryCertificate(payload))

    if (responseData && responseData.status === 400) {

    } else {
      let ele: any = JSON.parse(responseData && responseData.data)
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = ele;
      tempDiv.style.width = '800px';
      tempDiv.style.position = 'absolute';
      tempDiv.style.top = '-9999px';
      document.body.appendChild(tempDiv);
      html2canvas(tempDiv, { scale: 2, useCORS: true }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdfDOC = new jsPDF();
        const width = pdfDOC.internal.pageSize.getWidth();
        let height = pdfDOC.internal.pageSize.getHeight();
        pdfDOC.addImage(imgData, 'PNG', 0, 0, width, height);
        pdfDOC.save('certificate.pdf');
        document.body.removeChild(tempDiv);
        setLoading(false);
      });
    }
  }

  const onClickBrowseFileasync = async (type: any, item: any) => {
    setLoading(true);
    showErrorMessage(null);
    setSuccessMessage(null);
    handleopenCloseSnackbar(false);
    handleopenCloseErrorSnackbar(false);

    const name = item && item.name ? item.name : '',
      doctExtension = (name && name.substring(name.lastIndexOf('.') + 1, name.length)) || (name),
      doctExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'doc'],
      doctExtensionsforHO = ['jpg', 'png'],
      canUploadFile = (type === 'annexureToAgreement' || type === 'customerAgreement' || type === 'pictureOfHo') ? doctExtensions.indexOf(doctExtension.toLowerCase()) !== -1 : doctExtensionsforHO.indexOf(doctExtension.toLowerCase()) !== -1;
    if (!canUploadFile) {
      showErrorMessage('Invalid File type format');
      handleopenCloseErrorSnackbar(true);
      setLoading(false);
      return;
    }
    if ((type !== 'annexureToAgreement' && type === 'customerAgreement' && type !== 'pictureOfHo')) {
      if ((item && item.size < 25000000 && customerAgreement.length < 10)) {
        let keyAttribute = `fieldname=${type}&docExtension=${doctExtension}`;

        const customHeaders = {
          "Accept": "application/json",
          "Lob-Id": "AUTO",
          "Channel-Id": "B2B",
          "Org-Id": "",
          "Accept-Language": "EN",
        };

        let docType = '';
        if (type === 'customerAgreement') { docType = 'customerAgreement' }

        const formData: any = new FormData();
        formData.append("entityName", "CUSTOMER");
        formData.append("keyAttribute", keyAttribute);
        formData.append("fileUpload", item);
        formData.append("document", 'true');
        formData.append("Attributes", `key=Brand&value=${item}`);
        formData.append("sapCustomerId", sapCustomerId);
        formData.append("docType", docType);
        formData.append("label", type);
        formData.append("b2bUserId", b2bUserId ? b2bUserId : '');
        formData.append("uploadedByRole", 'kam');
        formData.append("uploadedBywebApplicationLoginId", '');
        formData.append("selectedFileName", item.name);
        formData.append("documentType", "customerAgreement");
        formData.append("uploadingUserName", displayName);

        try {
          let documentRes: any = await dispatch(updateCustomerAgreementDocument(formData, customHeaders))
          if (documentRes && documentRes.message && documentRes.message.status === 'S') {
            props.setDataUpdated(true);
            setLoading(false);
            setSuccessMessage('Document Uploaded Successfully');
            handleopenCloseSnackbar(true);
            setOpenDeleteDialog(false);
            setLoading(false);
            const label = documentRes?.data?.addDocument?.label;
            let fileIds = documentRes?.data?.addDocument?.fileIds
            if (label === "customerAgreement") {
              let po = [...customerAgreement];
              po.push({ documentId: documentRes.data.addDocument, fileIds: fileIds });
              setCustomerAgreement(po);
            }
          } else {
            showErrorMessage(documentRes?.error || 'Please try after sometime');
            handleopenCloseErrorSnackbar(true);
            setLoading(false);
          }
        } catch (error) {
          showErrorMessage('Document upload failed');
          handleopenCloseErrorSnackbar(true);
          setLoading(false);
        }
      } else if (customerAgreement.length >= 10 && type !== 'annexureToAgreement' && type === 'customerAgreement' && type !== 'pictureOfHo' && item && item.size < 25000000) {
        showErrorMessage('Should not exceed 10 files.');
        setLoading(false);
        handleopenCloseErrorSnackbar(true);
      } else if (type !== 'annexureToAgreement' && type === 'customerAgreement' && type !== 'pictureOfHo' && item && item.size > 25000000) {
        showErrorMessage('Please upload less than 25MB file.');
        handleopenCloseErrorSnackbar(true);
        setLoading(false);
      }
    } else if ((type === 'annexureToAgreement' && type !== 'customerAgreement' && type !== 'pictureOfHo')) {
      if ((item && item.size < 5000000 && annexureToAgreement.length < 10)) {
        let keyAttribute = `fieldname=${type}&docExtension=${doctExtension}`;

        const customHeaders = {
          "Accept": "application/json",
          "Lob-Id": "AUTO",
          "Channel-Id": "B2B",
          "Org-Id": "",
          "Accept-Language": "EN",
        };

        let docType = '';
        if (type === 'annexureToAgreement') { docType = 'annexureToAgreement' }

        const formData: any = new FormData();
        formData.append("entityName", "CUSTOMER");
        formData.append("keyAttribute", keyAttribute);
        formData.append("fileUpload", item);
        formData.append("document", 'true');
        formData.append("Attributes", `key=Brand&value=${item}`);
        formData.append("sapCustomerId", sapCustomerId);
        formData.append("docType", docType);
        formData.append("label", type);
        formData.append("b2bUserId", b2bUserId ? b2bUserId : '');
        formData.append("uploadedByRole", 'kam');
        formData.append("uploadedBywebApplicationLoginId", '');
        formData.append("selectedFileName", item.name);
        let documentRes: any = await dispatch(updateDocument(formData, customHeaders));
        if (documentRes && documentRes.message && documentRes.message.status === 'S') {
          props.setDataUpdated(true);
          setLoading(false);
          setSuccessMessage('Document Uploaded Successfully');
          handleopenCloseSnackbar(true);
          setOpenDeleteDialog(false);

          const { label, id } = documentRes.data;

          if (label === "annexureToAgreement") {
            let po = [...annexureToAgreement];
            po.push({ documentId: documentRes.data });
            setAnnexureToAgreement(po);
          }
        } else {
          showErrorMessage('Document upload failed');
          handleopenCloseErrorSnackbar(true);
          setLoading(false);
        }
      } else if (annexureToAgreement.length >= 10 && type === 'annexureToAgreement' && type !== 'customerAgreement' && type !== 'pictureOfHo' && item && item.size < 5000000) {
        showErrorMessage('Should not exceed 10 files.');
        setLoading(false);
        handleopenCloseErrorSnackbar(true);
      } else if (type === 'annexureToAgreement' && type !== 'customerAgreement' && type !== 'pictureOfHo' && item && item.size > 5000000) {
        showErrorMessage('Please upload less than 5MB file.');
        handleopenCloseErrorSnackbar(true);
        setLoading(false);
      }
    } else if (type !== 'annexureToAgreement' && type !== 'customerAgreement' && type === 'pictureOfHo') {
      if ((item && item.size < 2000000 && setPictureOfHo.length < 10)) {
        let keyAttribute = `fieldname=${type}&docExtension=${doctExtension}`;

        if (type == "pictureOfHo") {
          let po = [...setPictureOfHo];
          po.push({ documentId: item });
          SetPictureOfHo(po);
        }

        const customHeaders = {
          "Accept": "application/json",
          "Lob-Id": "AUTO",
          "Channel-Id": "B2B",
          "Org-Id": "",
          "Accept-Language": "EN",
        };

        let docType = '';
        if (type === 'pictureOfHo') { docType = 'pictureOfHo' }
        const formData: any = new FormData();
        formData.append("entityName", "CUSTOMER");
        formData.append("keyAttribute", keyAttribute);
        formData.append("fileUpload", item);
        formData.append("document", 'true');
        formData.append("Attributes", `key=Brand&value=${item}`);
        formData.append("sapCustomerId", sapCustomerId);
        formData.append("docType", docType);
        formData.append("label", type);
        formData.append("b2bUserId", b2bUserId ? b2bUserId : '');
        formData.append("uploadedByRole", 'kam');
        formData.append("uploadedBywebApplicationLoginId", '');
        formData.append("selectedFileName", item.name);
        let documentRes: any = await dispatch(updateDocument(formData, customHeaders));
        if (documentRes && documentRes.message && documentRes.message.status === 'S') {
          props.setDataUpdated(true);
          setLoading(false);
          setSuccessMessage('Document Uploaded Successfully');
          handleopenCloseSnackbar(true);
          setOpenDeleteDialog(false);

          const { label, id } = documentRes.data;

          if (label === "pictureOfHo") {
            let po = [...setPictureOfHo];
            po.push({ documentId: documentRes.data });
            SetPictureOfHo(po);
          }
        } else {
          showErrorMessage('Document upload failed');
          handleopenCloseErrorSnackbar(true);
          setLoading(false);
        }
      } else if (setPictureOfHo.length >= 10 && type !== 'annexureToAgreement' && type !== 'customerAgreement' && type === 'pictureOfHo' && item && item.size < 2000000) {
        showErrorMessage('Should not exceed 10 files.');
        handleopenCloseErrorSnackbar(true);
        setLoading(false);

      } else if (type !== 'annexureToAgreement' && type !== 'customerAgreement' && type === 'pictureOfHo' && item && item.size > 2000000) {
        showErrorMessage('Please upload less than 2MB file');
        handleopenCloseErrorSnackbar(true);
        setLoading(false);
      }
    }
    setLoading(false);
  }

  const removeDocument = async (type: any) => {
    props.setDataUpdated(true);
    dispatch(resetValues());
    let po = [...setPictureOfHo]
    let customerAgreementDoc = [...customerAgreement]
    let annexureToAgreementDoc = [...annexureToAgreement]

    const obj = {
      "type": type
    }

    if (type === "kamReview") {
      const documentId = po[currentIndex].documentId && po[currentIndex].documentId.id;
      let response: any = await dispatch(deleteDocument(sapCustomerId, documentId, obj));
      if (response && response.message && response.message.status === 'S') {
        po[currentIndex].documentId = null;
        po.splice(currentIndex, 1);
        SetPictureOfHo(po);
        setSuccessMessage(response.message.message);
        handleopenCloseSnackbar(true);
        setOpenDeleteDialog(false);
      } else {
        showErrorMessage(response?.error);
        handleopenCloseErrorSnackbar(true);
      }
    } else if (type === "customerAgreement") {
      const documentId = customerAgreementDoc[currentIndex].documentId && customerAgreementDoc[currentIndex].fileIds;
      let response: any = await dispatch(deleteDocument(sapCustomerId, documentId, obj));
      if (response && response.message && response.message.status === 'S') {
        customerAgreementDoc[currentIndex].documentId = null;
        customerAgreementDoc[currentIndex].fileIds = null;
        customerAgreementDoc.splice(currentIndex, 1);
        setCustomerAgreement(customerAgreementDoc);
        setSuccessMessage(response.message.message);
        handleopenCloseSnackbar(true);
        setOpenDeleteDialog(false);
      } else {
        showErrorMessage(response?.error);
        handleopenCloseErrorSnackbar(true);
      }
    } else if (type === "annexureToAgreement") {
      const documentId = annexureToAgreementDoc[currentIndex].documentId && annexureToAgreementDoc[currentIndex].documentId.id;
      let response: any = await dispatch(deleteDocument(sapCustomerId, documentId, obj));
      if (response && response.message && response.message.status === 'S') {
        annexureToAgreementDoc[currentIndex].documentId = null;
        annexureToAgreementDoc.splice(currentIndex, 1);
        setAnnexureToAgreement(annexureToAgreementDoc);
        setSuccessMessage(response.message.message);
        handleopenCloseSnackbar(true);
        setOpenDeleteDialog(false);
      } else {
        showErrorMessage(response?.error);
        handleopenCloseErrorSnackbar(true);
      }
    }
  }

  const customerAgreementKamAccess = () => {
    let selectedCustomerAgreement =
      getDocumentAccessKamListData && getDocumentAccessKamListData.data && getDocumentAccessKamListData.data.data &&
      getDocumentAccessKamListData.data.data.noDocumentAccessKAMList.some((item: any) => item && item.KAMId === webApplicationLoginId)
    return selectedCustomerAgreement
  }

  function onChangeSize(event: any, type: string) {
    props.setDataUpdated(true);
    let size = event.target.value;
    SetSize(size);
    if (size.length > 50) {
      SetSizeError(true);
      SetSizeValidationMessage(KamReviewValidationMessages.SIZE)
    } else {
      SetSizeError(false);
    }
  }

  function onChangeStock(event: any, type: string) {
    props.setDataUpdated(true);
    let stock = event.target.value
    SetStock(stock);
    if (stock.length > 50) {
      SetStockError(true);
      SetStockValidationMessage(KamReviewValidationMessages.STOCK)
    } else {
      SetStockError(false);
    }
  }

  function onChangeNumberOfStaff(event: any, type: string) {
    props.setDataUpdated(true);
    let numberOfStaff = event.target.value;
    SetNumberOfStaff(numberOfStaff);
    if (numberOfStaff.length > 100) {
      SetNumberOfStaffError(true);
      SetNumberOfStaffValidationMessage(KamReviewValidationMessages.NO_OF_STAFF)
    } else {
      SetNumberOfStaffError(false);
    }
  }

  function onChangeSalesToCustomer(event: any, type: string) {
    props.setDataUpdated(true);
    let salesToCustomer = event.target.value;
    SetSalesToCustomer(salesToCustomer);
    if (salesToCustomer.length > 100) {
      SetSalesToCustomerError(true);
      SetSalesToCustomerValidationMessage(KamReviewValidationMessages.SALES_TO_CUSTOMER)
    } else {
      SetSalesToCustomerError(false);
    }
  }

  function onChangePaymentHistory(event: any, type: string) {
    props.setDataUpdated(true);
    let paymentHistory = event.target.value
    SetPaymentHistory(paymentHistory);
    if (!paymentHistory && paymentHistory === " " && paymentHistory === undefined) {
      if (paymentHistory.length > 500) {
        SetPaymentHistoryError(true);
        SetPaymentHistoryValidationMessage(KamReviewValidationMessages.PAYMENT_HISTORY)
      }
    } else {
      SetPaymentHistoryError(false);
    }
  }

  function onChangeGrowthPlan(event: any, type: string) {
    props.setDataUpdated(true);
    let growthPlan = event.target.value;
    SetGrowthPlan(growthPlan);
    if (growthPlan.length > 500) {
      SetGrowthPlanError(true);
      SetGrowthPlanValidationMessage(KamReviewValidationMessages.GROWTH_PLAN)
    } else {
      SetGrowthPlanError(false);
    }
  }

  function datePickerValid(e: any, state: any) {
    if (e === "") {
      return;
    } else {
      if (e === "Invalid Date Format") {
        setError("Invalid Date Format");
        state(true);
      } else {
        var varDate = new Date(setSalesSince);
        var today = new Date();
        if (varDate > today) {
          setInvalidDate(true);
          setError('Date should be less than today date.')
          SetSalesSinceError(true);
        } else {
          SetSalesSinceError(false);
          state(false);
          setError(null)
        }
      }
    }
  }

  // BASED ON - GVT CUSTOMER CHANGES
  function isGovernment() {
    if (sessionStorage.getItem('customerOnboardingType') == 'Dealer' || sessionStorage.getItem('customerOnboardingType') === 'tpcdealer' || sessionStorage.getItem('customerOnboardingType') == 'dealer' ||
      sessionStorage.getItem('customerOnboardingType') == 'workshop' || sessionStorage.getItem('customerOnboardingType') == 'Workshop') {
      return false
    } else {
      return true
    }
  }

  return (
    <Fragment>
      {loading && <FullscreenLoader />}
      <div className="row-space-start col-12 p-3">
        <>
          <div className="col-12 m-0 p-0">
            <div className="row mt-0 mb-1">
              <h6 className="dealer-table-content mb-1 px-4 mt-3 mb-0">KAM Review</h6>
            </div>
            {isEditDealer ? (<>
              {sessionStorage.getItem('customerOnboardingType') === 'Dealer' || sessionStorage.getItem('customerOnboardingType') === "TBL Dealer" || sessionStorage.getItem('customerOnboardingType') === 'tpcdealer' || sessionStorage.getItem('customerOnboardingType') === "Int. Business" || sessionStorage.getItem('customerOnboardingType') === 'dealer' || sessionStorage.getItem('customerOnboardingType') === 'workshop' || sessionStorage.getItem('customerOnboardingType') === 'Workshop' ?
                <div className="row mb-1 mt-0 px-3">
                  <div className="col-sm-12 col-md-4 col-sm-4 px-1 pr-2 mb-1 mt-2 row-space-between ">
                    <TextField id="size"
                      required={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : isGovernment() ? false : true}
                      type="text"
                      value={setSize}
                      error={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setSizeError}
                      helperText={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setSizeError && setSize && <span style={{ color: 'red' }}>{setSizeValidationMessage}</span>}
                      onChange={(e: any) => onChangeSize(e, "size")}
                      size="small" className="col-sm-12 my-2 commonRoundedInputs"
                      label="Size" variant="outlined">
                    </TextField>
                  </div>
                  <div className="col-sm-12 col-md-4 col-sm-4 px-3 pr-2 mb-1 mt-2 row-space-between">
                    <TextField id="stockQuantityValue"
                      required={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : sessionStorage.getItem('customerOnboardingType') === "Int. Business" ? false : true}
                      value={setStock}
                      disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                      error={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setStockError}
                      helperText={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setStockError && setStock && <span style={{ color: 'red' }}>{setStockValidationMessage}</span>}
                      onChange={(e: any) => onChangeStock(e, "stock")}
                      size="small" className="col-sm-12 my-2 commonRoundedInputs"
                      label="Stock(quantity & value)" variant="outlined" margin="dense">
                    </TextField>
                  </div>
                  <div className="col-sm-12 col-md-4 col-sm-4 px-3 pr-2 mb-1 mt-2 row-space-between">
                    <TextField id="noOfStaff"
                      required={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : sessionStorage.getItem('customerOnboardingType') === "Int. Business" ? false : true}
                      value={setNumberOfStaff}
                      disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                      error={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setNumberOfStaffError}
                      helperText={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setNumberOfStaffError && setNumberOfStaff && <span style={{ color: 'red' }}>{setNumberOfStaffValidationMessage}</span>}
                      onChange={(e: any) => onChangeNumberOfStaff(e, "numberOfStaff")}
                      size="small" className="col-sm-12 my-2 commonRoundedInputs"
                      label="No. of Staff" variant="outlined" margin="dense">
                    </TextField>
                  </div>
                </div>
                : ""}
              {sessionStorage.getItem('customerOnboardingType') === 'Fleet' ?
                <div className="row mb-1 mt-0 px-3">
                  <div className="col-sm-12 col-md-4 col-sm-4 px-1 pr-2 mb-1 mt-2 row-space-between ">
                    <TextField id="size"
                      type="text"
                      value={setSize}
                      onChange={(e: any) => onChangeSize(e, "size")}
                      size="small" className="col-sm-12 my-2 commonRoundedInputs"
                      label="Size" variant="outlined">
                    </TextField>
                  </div>
                  <div className="col-sm-12 col-md-4 col-sm-4 px-3 pr-2 mb-1 mt-2 row-space-between">
                    <TextField id="stockQuantityValue"
                      value={setStock}
                      disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                      onChange={(e: any) => onChangeStock(e, "stock")}
                      size="small" className="col-sm-12 my-2 commonRoundedInputs"
                      label="Stock(quantity & value)" variant="outlined" margin="dense">
                    </TextField>
                  </div>
                  <div className="col-sm-12 col-md-4 col-sm-4 px-3 pr-2 mb-1 mt-2 row-space-between">
                    <TextField id="noOfStaff"
                      value={setNumberOfStaff}
                      disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                      onChange={(e: any) => onChangeNumberOfStaff(e, "numberOfStaff")}
                      size="small" className="col-sm-12 my-2 commonRoundedInputs"
                      label="No. of Staff" variant="outlined" margin="dense">
                    </TextField>
                  </div>
                </div>
                : ""}
              <div className="row mb-1 mt-2 px-3">
                <div className="col-sm-12 col-md-4 col-sm-4 px-1 pr-2 mb-3 mt-0 row-space-between salestoCustomerKam">
                  {sessionStorage.getItem('customerOnboardingType') === "Int. Business" ?
                    <TextField
                      select disabled id="salesToCustomer"
                      defaultValue={ibCurrency}
                      value={ibCurrency} className="col-sm-2 commonRoundedInputs-dropdown"
                      margin="dense"
                      variant="outlined" style={{ width: '74px' }}>
                      <MenuItem key={ibCurrency} value={ibCurrency}>{ibCurrency}</MenuItem>
                    </TextField>
                    :
                    <TextField
                      select disabled id="salesToCustomer"
                      defaultValue={setSalesToCustomerCurrencyType}
                      value={setSalesToCustomerCurrencyType} className="col-sm-2 commonRoundedInputs-dropdown"
                      margin="dense"
                      error={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setSalesToCustomerCurrencyTypeError}
                      helperText={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setSalesToCustomerCurrencyTypeError && setSalesToCustomerCurrencyType && <span style={{ color: 'red' }}>{setSalesToCustomerCurrencyTypeValidationMessage}</span>}
                      variant="outlined" style={{ width: '74px' }}>
                      {currencies.map(item => (
                        <MenuItem key={item} value={item}>{item}</MenuItem>))}
                    </TextField>}
                  <TextField id="salesToCustomer"
                    required={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : isGovernment() ? false : true}
                    value={setSalesToCustomer}
                    disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                    error={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setSalesToCustomerError}
                    helperText={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setSalesToCustomerError && setSalesToCustomer && <span style={{ color: 'red' }}>{setSalesToCustomerValidationMessage}</span>}
                    onChange={(e: any) => onChangeSalesToCustomer(e, "salesToCustomer")}
                    size="small" className="col-sm-10 commonRoundedInputs-textfield" style={{ maxHeight: '36px' }}
                    label="Sales to customer in last 6 months" variant="outlined" margin="dense" />
                </div>
                <div className="col-sm-12 col-md-4 col-sm-4 px-3 pr-2 mb-3 mt-1 row-space-between">
                  <KeyboardDatePicker
                    required={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : isGovernment() ? false : true}
                    disableFuture
                    disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                    views={["year"]}
                    openTo="year"
                    autoOk size="small" disableToolbar variant="inline" inputVariant="outlined"
                    onError={(e, v) => datePickerValid(e, setInvalidDate)}
                    format="yyyy" margin="normal" label="After Sales Since" value={setSalesSince}
                    onChange={(date: Date | null) => {
                      props.setDataUpdated(true);
                      if (date) {
                        let newDate = moment(date).format('YYYY');
                        SetSalesSince(newDate);
                        if (newDate != "Invalid Date") {
                          SetSalesSinceError(false)
                        }
                      } else {
                        SetSalesSince("");
                        SetSalesSinceError(true)
                      }
                    }}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    className="rounded-input-dealer w-100 mt-2 cal-icon"
                    error={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setSalesSinceError || invalidDate}
                    helperText={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : invalidDate && <span style={{ color: 'red' }}>{error}</span>}
                  />
                </div>
                <div className="col-sm-12 col-md-4 col-sm-4 px-3 pr-2 mb-3 mt-1 row-space-between">
                  <TextField id="paymentHistory"
                    select
                    required={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : isGovernment() ? false : true}
                    value={setPaymentHistory}
                    disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                    error={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setPaymentHistoryError}
                    helperText={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setPaymentHistoryError && setPaymentHistory && <span style={{ color: 'red' }}>{setPaymentHistoryValidationMessage}</span>}
                    onChange={(e: any) => onChangePaymentHistory(e, "paymentHistory")}
                    size="small" className="col-sm-12 my-2 commonRoundedInputs"
                    label="Payment History" variant="outlined" margin="dense">
                    <MenuItem key={'good'} value={'good'}>{'Good'}</MenuItem>
                    <MenuItem key={'bad'} value={'bad'}>{'Bad'}</MenuItem>
                    <MenuItem key={'excellent'} value={'excellent'}>{'Excellent'}</MenuItem>
                    <MenuItem key={'newCustomer'} value={'newCustomer'}>{'New Customer'}</MenuItem>
                  </TextField>
                </div>
              </div>
              <div className="row mb-1 mt-1 px-3">
                <div className="col-sm-12 col-md-4 col-sm-4 px-1 pr-2 mb-3 mt-0 row-space-between salestoCustomerKam">
                  <TextField select id="selectIndustry" value={companyIndustrySector}
                    label="Select Industry Type" required variant="outlined" margin="dense"
                    disabled={dealerstatus && dealerstatus === "Deactive" || isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? true : false}
                    size="small" className="col-sm-12 my-2 commonRoundedInputs hiddenNo" type="number"
                    error={selectedIndustryTypeError || invalidSelectedIndustryType}
                    helperText={invalidSelectedIndustryType && <span style={{ color: 'red' }}>Please select the industry type.</span>}
                    onChange={(e: any) => {
                      props.setDataUpdated(true);
                      setCompanyIndustrySector(e.target.value);
                    }}
                  >
                    {getIndustryTypeAPI && getIndustryTypeAPI.data && getIndustryTypeAPI.data.length > 0 &&
                      getIndustryTypeAPI.data[0] && getIndustryTypeAPI.data[0] && getIndustryTypeAPI.data[0].companyIndustrySector &&
                      getIndustryTypeAPI.data[0].companyIndustrySector.length > 0 && getIndustryTypeAPI.data[0].companyIndustrySector.map((item: any) => (
                        <MenuItem key={item.code} value={item.code}>{item.title} </MenuItem>))}
                  </TextField>
                </div>
                <div className={sessionStorage.getItem('customerOnboardingType') === 'Government' ? "px-3 col-sm-12 col-md-4 col-sm-4 px-1 pr-2 mb-3 mt-0 row-space-between salestoCustomerKam" : "px-3 col-sm-12 col-md-8 col-sm-8 px-1 pr-2 mb-3 mt-0 row-space-between salestoCustomerKam"}>
                  <TextField id="growthPlan"
                    required={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : isGovernment() ? false : true}
                    value={setGrowthPlan}
                    disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                    error={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setGrowthPlanError}
                    helperText={isTpcDealer ? false : isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? false : setGrowthPlanError && setGrowthPlan && <span style={{ color: 'red' }}>{setGrowthPlanValidationMessage}</span>}
                    onChange={(e: any) => onChangeGrowthPlan(e, "growthPlan")}
                    size="small" className="col-sm-12 my-2 commonRoundedInputs"
                    label="Growth Plan" variant="outlined" margin="dense">
                  </TextField>
                </div>
                {sessionStorage.getItem('customerOnboardingType') === 'Government' ?
                  <div className="col-sm-4 col-md-4 col-sm-4 px-1 pr-2 mb-4 mt-2 row-space-between ">
                    <TextField id="size"
                      required={isGovernment() ? false : true}
                      type="text"
                      value={setSize}
                      disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                      error={setSizeError}
                      helperText={setSizeError && setSize && <span style={{ color: 'red' }}>{setSizeValidationMessage}</span>}
                      onChange={(e: any) => onChangeSize(e, "size")}
                      size="small" className="col-sm-12 my-2 commonRoundedInputs"
                      label="Size" variant="outlined">
                    </TextField>
                  </div> : ""}
              </div>
            </>) : (<>
              <div className="row col-12">
                <div className="col-4">
                  <div className="info-sub-title mt-3">Size</div>
                  <div className="info-sub-title-value mt-2">{setSize ? setSize : '-'}</div>
                </div>
                {sessionStorage.getItem('customerOnboardingType') === 'Government' ?
                  "" : <div className="col-4">
                    <div className="info-sub-title">Stock(quantity & value)</div>
                    <div className="info-sub-title-value mt-2">{setStock ? setStock : '-'}</div>
                  </div>}
                {sessionStorage.getItem('customerOnboardingType') === 'Government' ?
                  "" :
                  <div className="col-4">
                    <div className="info-sub-title">No. of Staff</div>
                    <div className="info-sub-title-value mt-2">{setNumberOfStaff ? setNumberOfStaff : '-'}</div>
                  </div>}
                <div className="col-4 mt-3">
                  <div className="info-sub-title">Sales to customer</div>
                  <div className="info-sub-title-value mt-2">{setSalesToCustomer ? setSalesToCustomer : '-'}</div>
                </div>
                <div className="col-4 mt-3">
                  <div className="info-sub-title">After Sales Since</div>
                  <div className="info-sub-title-value mt-2">{setSalesSince ? setSalesSince : '-'}</div>
                </div>
                <div className="col-4 mt-3">
                  <div className="info-sub-title">Payment History</div>
                  <div className="info-sub-title-value mt-2">{setPaymentHistory ? setPaymentHistory : '-'}</div>
                </div>
                <div className="col-4 mt-3">
                  <div className="info-sub-title">Industry Type</div>
                  <div className="info-sub-title-value mt-2">{companyIndustrySector ? companyIndustrySector : '-'}</div>
                </div>
                <div className="col-4 mt-3">
                  <div className="info-sub-title">Growth Plan</div>
                  <div className="info-sub-title-value mt-2">{setGrowthPlan ? setGrowthPlan : '-'}</div>
                </div>
              </div>
            </>)}
          </div>
        </>
      </div>
      {sessionStorage.getItem('customerOnboardingType') === "Int. Business" || isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? "" :
        <div className="col-12 m-0 p-0 border-top border-bottom">
          <div className="row px-3 mb-2">
            <div className="col-md-3 col-lg-3 pr-2 pt-3 mb-4 px-4 pl-0 ">
              {isAddedByFse && sessionStorage.getItem('customerOnboardingType') === "Workshop" ? "" : sessionStorage.getItem('customerOnboardingType') === 'Government' || sessionStorage.getItem('customerOnboardingType') === 'Fleet' || isTpcDealer ?
                <h6 className="document-content pt-3 pb-4">Picture Of HO <span style={{ color: 'grey' }}></span></h6> :
                <h6 className="document-content pt-3 pb-4">Picture Of HO <span style={{ color: 'grey' }}>*</span></h6>}
              {isEditDealer && (
                <small className="dealer-table-content">Photos(.jpg, .jpeg, .png  and maximum 10 files upto 2 MB can be uploaded)</small>
              )}
            </div>
            {isEditDealer && (
              <div className="col-md-4 col-lg-4 col-sm-4 mb-2 pl-0 mt-4 px-4">
                <Button variant="contained"
                  disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                  component="label" color="secondary"
                  className="rounded-button-dealer pl-4 pr-4 mt-0">
                  Browse File
                  <input type="file" hidden multiple
                    onChange={(e) =>
                      (e.target && e.target.files) ?
                        onClickBrowseFileasync("pictureOfHo", e.target.files[0]) : ""
                    }
                  />
                </Button>
                {sessionStorage.getItem('customerOnboardingType') === 'Government' || sessionStorage.getItem('customerOnboardingType') === 'Fleet' || isTpcDealer ?
                  ""
                  :
                  <>
                    {(!setPictureOfHo || setPictureOfHo.length == 0) && setSave ?
                      <div style={{ color: 'red' }}>Please upload the Picture Atleast one</div> : ""}
                  </>
                }
              </div>
            )}
            <div className="col-md-4 col-lg-4 col-sm-4 mb-2 pt-2 pl-0 mt-2">
              {setPictureOfHo && setPictureOfHo.length > 0 && setPictureOfHo.map((file: any, index: any) => (
                <div className="file-name-kam mt-2">
                  <span className="cursor-pointer"
                    onClick={() => {
                      window.open(file.documentId.url)
                    }}
                  >{file.documentId && file.documentId.name ? file.documentId.name : file.documentId && file.documentId.selectedFileName}</span>
                  {file.documentId && file.documentId.selectedFileName && isEditDealer ? (
                    <IconButton className="p-1" aria-label="delete"
                      disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                      onClick={(e: any) => { deleteDocumentDialog("kamReview"); setCurrentIndex(index) }}>
                      <CancelIcon className="file-close-color" fontSize="small" />
                    </IconButton>
                  ) : ''}
                </div>
              ))}
            </div>
          </div>
        </div>
      }
      {sessionStorage.getItem('customerOnboardingType') !== "TBL Dealer" && (
        <>
          {sessionStorage.getItem('customerOnboardingType') === "Int. Business" && sessionStorage.getItem('customerOnboardingType') !== "TBL Dealer" || userType === "FSE" && sessionStorage.getItem('customerOnboardingType') !== "TBL Dealer" || customerAgreementKamAccess() && sessionStorage.getItem('customerOnboardingType') !== "TBL Dealer" ? "" :
            <div className='card col-12 border-right-0 border-top-0 border-left-0'>
              <h6 className="page-sub-title pt-3 pb-2 px-3">Al-Futtaim Customer Agreement<span style={{ color: 'grey' }}></span></h6>
            </div>
          }
          {sessionStorage.getItem('customerOnboardingType') === "Dealer" ?
             <div className="col-12 m-0 p-0 border-top border-bottom">
             <div className="row px-3 mb-2">
               <div className="col-md-3 col-lg-3 pr-2 pt-3 mb-4 px-4 pl-0 ">
                 <h6 className="document-content pt-3 pb-4">Category Certificate <span style={{ color: 'grey' }}></span></h6>
                 {isEditDealer && (
                   <small className="dealer-table-content">(Silver/Gold/Platinum/Elite)</small>
                 )}
               </div>
               <div className={isEditDealer ? "col-md-4 col-lg-4 col-sm-4 mb-2 pt-2 pl-0 mt-2 px-4" : "col-md-4 col-lg-4 col-sm-4 mb-2 pt-2 pl-0 mt-2"}>
                 <div className="file-name-kam mt-2">
                   <span className="cursor-pointer"
                     onClick={() => {
                       downloadCertificate();
                     }}
                   >{"Certificate.Pdf"}</span>
                   <IconButton className="p-1" aria-label="delete"
                     onClick={(e: any) => { downloadCertificate(); }}>
                     <AssignmentReturnedIcon className="file-close-color" fontSize="small" />
                   </IconButton>
                 </div>
               </div>
               <div className="col-md-4 col-lg-4 col-sm-4 mb-2 pl-0 mt-4">
               </div>
             </div>
           </div>
          : ""}
          {sessionStorage.getItem('customerOnboardingType') === "Int. Business" && sessionStorage.getItem('customerOnboardingType') !== "TBL Dealer" || userType === "FSE" && sessionStorage.getItem('customerOnboardingType') !== "TBL Dealer" || customerAgreementKamAccess() && sessionStorage.getItem('customerOnboardingType') !== "TBL Dealer" ? "" :
            <>
              <div className="col-12 m-0 p-0 border-top border-bottom">
                <div className="row px-3 mb-2">
                  <div className="col-md-3 col-lg-3 pr-2 pt-3 mb-4 px-4 pl-0 ">
                    <h6 className="document-content pt-3 pb-4">Customer Agreement <span style={{ color: 'grey' }}></span></h6>
                    {isEditDealer && (
                      <small className="dealer-table-content">('pdf' and maximum 10 files upto 25 MB can be uploaded)</small>
                    )}
                  </div>
                  {isEditDealer && (
                    <div className="col-md-4 col-lg-4 col-sm-4 mb-2 pl-0 mt-4 px-4">
                      <Button variant="contained"
                        disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                        component="label" color="secondary"
                        className="rounded-button-dealer pl-4 pr-4 mt-0">
                        Browse File
                        <input type="file" hidden multiple accept="application/pdf"
                          onChange={(e) => {
                            (e.target && e.target.files) ?
                              onClickBrowseFileasync("customerAgreement", e.target.files[0]) : ""
                          }
                          }
                        />
                      </Button>
                    </div>
                  )}
                  <div className="col-md-4 col-lg-4 col-sm-4 mb-2 pt-2 pl-0 mt-2">
                    {customerAgreement && customerAgreement.length > 0 && customerAgreement.map((file: any, index: any) => (
                      <div className="file-name-kam mt-2">
                        <span className="cursor-pointer"
                          onClick={() => {
                            downloadCustomerAgreement(file);
                            setCurrentIndex(index);
                          }}
                        >{file.documentId && file.documentId.name ? file.documentId.name : file.documentId && file.documentId.selectedFileName}</span>
                        {file.documentId && file.documentId.selectedFileName && isEditDealer ? (
                          <IconButton className="p-1" aria-label="delete"
                            disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                            onClick={(e: any) => { deleteDocumentDialog("customerAgreement"); setCurrentIndex(index) }}>
                            <CancelIcon className="file-close-color" fontSize="small" />
                          </IconButton>
                        ) : ''}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-12 m-0 p-0 border-top">
                <div className="row px-3 mb-2">
                  <div className="col-md-3 col-lg-3 pr-2 pt-3 mb-4 px-4 pl-0 ">
                    <h6 className="document-content pt-3 pb-4">Annexure To Agreement <span style={{ color: 'grey' }}></span></h6>
                    {isEditDealer && (
                      <small className="dealer-table-content">('jpg', 'jpeg', 'png', 'pdf', 'doc' and maximum 10 files upto 5 MB can be uploaded)</small>
                    )}
                  </div>
                  {isEditDealer && (
                    <div className="col-md-4 col-lg-4 col-sm-4 mb-2 pl-0 mt-4 px-4">
                      <Button variant="contained"
                        disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                        component="label" color="secondary"
                        className="rounded-button-dealer pl-4 pr-4 mt-0">
                        Browse File
                        <input type="file" hidden multiple
                          onChange={(e) =>
                            (e.target && e.target.files) ?
                              onClickBrowseFileasync("annexureToAgreement", e.target.files[0]) : ""
                          }
                        />
                      </Button>
                    </div>
                  )}
                  <div className="col-md-4 col-lg-4 col-sm-4 mb-2 pt-2 pl-0 mt-2">
                    {annexureToAgreement && annexureToAgreement.length > 0 && annexureToAgreement.map((file: any, index: any) => (
                      <div className="file-name-kam mt-2">
                        <span className="cursor-pointer"
                          onClick={() => {
                            window.open(file.documentId.url)
                          }}
                        >{file.documentId && file.documentId.name ? file.documentId.name : file.documentId && file.documentId.selectedFileName}</span>
                        {file.documentId && file.documentId.selectedFileName && isEditDealer ? (
                          <IconButton className="p-1" aria-label="delete"
                            disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                            onClick={(e: any) => { deleteDocumentDialog("annexureToAgreement"); setCurrentIndex(index) }}>
                            <CancelIcon className="file-close-color" fontSize="small" />
                          </IconButton>
                        ) : ''}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          }
        </>
      )}
      {!customerAgreementKamAccess() && sessionStorage.getItem('customerOnboardingType') === "TBL Dealer" ?
        <div className='card col-12 border-right-0 border-top-0 border-left-0'>
          <h6 className="page-sub-title pt-3 pb-4 px-3">Al-Futtaim Customer Agreement<span style={{ color: 'grey' }}></span></h6>
        </div>
        : ""}
      {!customerAgreementKamAccess() && sessionStorage.getItem('customerOnboardingType') === "TBL Dealer" ?
        <>
          <div className="col-12 m-0 p-0 border-top border-bottom">
            <div className="row px-3 mb-2">
              <div className="col-md-3 col-lg-3 pr-2 pt-3 mb-4 px-4 pl-0 ">
                <h6 className="document-content pt-3 pb-4">Customer Agreement <span style={{ color: 'grey' }}></span></h6>
                {isEditDealer && (
                  <small className="dealer-table-content">('jpg', 'jpeg', 'png', 'pdf', 'doc' and maximum 10 files upto 25 MB can be uploaded)</small>
                )}
              </div>
              {isEditDealer && (
                <div className="col-md-4 col-lg-4 col-sm-4 mb-2 pl-0 mt-4 px-4">
                  <Button variant="contained"
                    disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                    component="label" color="secondary"
                    className="rounded-button-dealer pl-4 pr-4 mt-0">
                    Browse File
                    <input type="file" hidden multiple
                      onChange={(e) =>
                        (e.target && e.target.files) ?
                          onClickBrowseFileasync("customerAgreement", e.target.files[0]) : ""
                      }
                    />
                  </Button>
                </div>
              )}
              <div className="col-md-4 col-lg-4 col-sm-4 mb-2 pt-2 pl-0 mt-2">
                {customerAgreement && customerAgreement.length > 0 && customerAgreement.map((file: any, index: any) => (
                  <div className="file-name-kam mt-2">
                    <span className="cursor-pointer"
                      onClick={() => {
                        downloadCustomerAgreement(file);
                        setCurrentIndex(index);
                      }}
                    >{file.documentId && file.documentId.name ? file.documentId.name : file.documentId && file.documentId.selectedFileName}</span>
                    {file.documentId && file.documentId.selectedFileName && isEditDealer ? (
                      <IconButton className="p-1" aria-label="delete"
                        disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                        onClick={(e: any) => { deleteDocumentDialog("customerAgreement"); setCurrentIndex(index) }}>
                        <CancelIcon className="file-close-color" fontSize="small" />
                      </IconButton>
                    ) : ''}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-12 m-0 p-0 border-top">
            <div className="row px-3 mb-2">
              <div className="col-md-3 col-lg-3 pr-2 pt-3 mb-4 px-4 pl-0 ">
                <h6 className="document-content pt-3 pb-4">Annexure To Agreement <span style={{ color: 'grey' }}></span></h6>
                {isEditDealer && (
                  <small className="dealer-table-content">('jpg', 'jpeg', 'png', 'pdf', 'doc' and maximum 10 files upto 5 MB can be uploaded)</small>
                )}
              </div>
              {isEditDealer && (
                <div className="col-md-4 col-lg-4 col-sm-4 mb-2 pl-0 mt-4 px-4">
                  <Button variant="contained"
                    disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                    component="label" color="secondary"
                    className="rounded-button-dealer pl-4 pr-4 mt-0">
                    Browse File
                    <input type="file" hidden multiple
                      onChange={(e) =>
                        (e.target && e.target.files) ?
                          onClickBrowseFileasync("annexureToAgreement", e.target.files[0]) : ""
                      }
                    />
                  </Button>
                </div>
              )}
              <div className="col-md-4 col-lg-4 col-sm-4 mb-2 pt-2 pl-0 mt-2">
                {annexureToAgreement && annexureToAgreement.length > 0 && annexureToAgreement.map((file: any, index: any) => (
                  <div className="file-name-kam mt-2">
                    <span className="cursor-pointer"
                      onClick={() => {
                        window.open(file.documentId.url)
                      }}
                    >{file.documentId && file.documentId.name ? file.documentId.name : file.documentId && file.documentId.selectedFileName}</span>
                    {file.documentId && file.documentId.selectedFileName && isEditDealer ? (
                      <IconButton className="p-1" aria-label="delete"
                        disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                        onClick={(e: any) => { deleteDocumentDialog("annexureToAgreement"); setCurrentIndex(index) }}>
                        <CancelIcon className="file-close-color" fontSize="small" />
                      </IconButton>
                    ) : ''}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
        : ""}
      <DeleteDialog
        open={openDeleteDialog}
        text="Are you sure you want to delete File ?"
        handleopenClose={(data: any) => {
          if (data === 'delete') removeDocument(deleteDocumentRemovalType);
          if (!data) handleopenClose(false);
        }} />
      {isEditDealer && (
        <ActionButtons
          openRequestSnackbar={true}
          deactiveShow={true}
          dealerDetails={dealerDetails}
          dealerStatus={dealerstatus}
          saveCallback={() => {
            saveValidation();
          }}
        />
      )}
      <Snackbar
        open={openSnackbar}
        handleopenClose={() => {
          handleopenCloseSnackbar(false)
        }} message={successMessage} />
      <Snackbar
        open={openErrorSnackbar}
        type="error"
        handleopenClose={() => {
          handleopenCloseErrorSnackbar(false)
        }} message={errorMessage} />
    </Fragment>
  )
}

export default KamReview;